<div class="mini-icon" [class]="color">
  <ion-icon *ngIf="icon" [src]="icon"></ion-icon>
</div>
<div class="mini-content">
  <ng-content></ng-content>
</div>
<div class="mini-learn-more" *ngIf="topic">
  <sc-learn-more [topic]="topic"></sc-learn-more>
</div>
